import myRoutes from './my'
import couponRoutes from './coupon'
import getOrderRoute from './order'
import activity from './activity'
import helpcenter from './helpcenter'
import shopcart from './shopcart'
import groupon from './groupon'
import recycle from './recycle'
import getProductRoutes from './product'

const routes = [
  ...myRoutes,
  ...couponRoutes,
  ...activity,
  ...helpcenter,
  ...shopcart,
  ...groupon,
  ...recycle,
  // 首页
  {
    path: '/',
    name: 'home',
    alias: ['/home', '/index.html'],
    meta: { type: 'page', title: 'vivo智能手机官方商城', stParams: {} },
    component: () => import(/* webpackChunkName: "home" */ 'views/home')
  },
  // 商详页离屏渲染模板
  {
    path: '/app/default.html',
    name: 'default.html',
    meta: { 
      type: 'page', 
      title: 'vivo智能手机官方商城', 
      stParams: {}, 
      lightDark: 1, // 深色模式的情况下是否自定义反色，0：删除meta自动反色，1：引入meta关闭自动反色 
    },
    component: () => import(/* webpackChunkName: 'product' */ 'views/product/detail/index/index.vue')
  },
  // 404
  {
    path: '*',
    name: 'vivo智能手机官方商城',
    meta: {
      type: 'page',
      title: 'vivo智能手机官方商城',
      stParams: {}
    },
    component: () => import(/* webpackChunkName: '404' */ 'views/error/404')
  },
  // forbidden
  {
    path: '/error/forbidden',
    name: 'forbidden',
    meta: { type: 'page', title: 'vivo智能手机官方商城', stParams: {} },
    component: () => import(/* webpackChunkName: 'forbidden' */ 'views/error/forbidden')
  },
  {
    path: '/my/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ 'views/login')
  },
  {
    path: '/transfer',
    name: 'Transfer',
    meta: {
      type: 'page',
      title: 'vivo智能手机官方商城',
      stParams: {}
    },
    component: () => import(/* webpackChunkName: "transfer" */ 'views/transfer')
  },
  {
    path: '/track',
    name: 'Track',
    meta: {
      type: 'page',
      title: 'vivo智能手机官方商城',
      stParams: {}
    },
    component: () => import(/* webpackChunkName: "track" */ 'views/track')
  },
  {
    path: '/enterprise',
    name: 'Enterprise',
    meta: {
      type: 'page',
      title: 'vivo智能手机官方商城',
      stParams: {}
    },
    component: () => import(/* webpackChunkName: "enterprise" */ 'views/enterprise')
  }
]
const fontRoute = [
  {
    path: '/font',
    name: 'FontReview',
    component: () => import(/* webpackChunkName: "fontreview" */ 'views/font/index')
  }
]

export default function (pageType) {
  return [...getProductRoutes(pageType), ...getOrderRoute(pageType), ...routes, ...fontRoute]
}
